<template>
    <section class="meetings">
        <section class="meetings-top">
            <section class="meetings-top__left">
                <img
                    src="../../../../../assets/icons/panel/home/warning.svg"
                    class="meetings-top__icon"
                />
                <span class="meetings-top__title">{{$t('com.file.meetings.next-meetings')}}</span> 
            </section>
            <section class="meetings-top__right">
                <section
                    v-for="button in filterButtons"
                    :key="button.id"
                    class="meetings-top__btn-wrapper"
                >
                    <FilterButton
                        :name="button.name"
                        :selected="button.selected"
                        @click="button.handler"
                    />
                </section>
            </section>
        </section>
        <section class="meetings__bottom" v-if="currentView === 'all'">
            <SmallLoader v-if="isLoading" />
            <section v-for="meeting in meetings" :key="meeting.id">
                <MeetingsWrapper
                    :name="meeting.name"
                    :date="formatDateToDisplay(meeting.date, 'weekdayDate')"
                    :list="meeting.meetingsList"
                />
            </section>
        </section>
        <section class="meetings__bottom" v-else>
            <SmallLoader v-if="isLoading" />
            <MeetingsWrapper
                :name="meetings[currentView].name"
                :date="formatDateToDisplay(meetings[currentView].date, 'weekdayDate')"
                :list="meetings[currentView].meetingsList"
            />
        </section>
    </section>
</template>

<script>
import MeetingsService from "../../../../../services/meetings.service";
import MeetingsWrapper from "./MeetingsWrapper.vue";
import FilterButton from "./FilterButton";
import SmallLoader from "../../../../BasicControls/SmallLoader.vue";
import { formatDateToDisplay } from "../../../../../helpers/i18n.utils";
import moment from "moment";

export default {
    name: "Meetings",
    data() {
        return {
            filterButtons: [
                {
                    id: 0,
                    name: this.$t('com.file.meetings.all'),
                    selected: true,
                    handler: () => {
                        this.reloadAllData();
                        this.handleChangeFilterButton(0);
                    },
                },
                {
                    id: 1,
                    name: this.$t('com.file.meetings.today'),
                    selected: false,
                    handler: () => {
                        this.sessionsToday();
                        this.currentView = 0;
                        this.handleChangeFilterButton(1);
                    },
                },
                {
                    id: 3,
                    name: this.$t('com.file.meeting.next-meetings'),
                    date: '',
                    selected: false,
                    handler: () => {
                        this.sessionsThisWeek();
                        this.currentView = 1;
                        this.handleChangeFilterButton(2);
                    },
                },
            ],
            isLoading: false,
            currentView: "all",
            meetings: [
                {
                    id: 0,
                    filterDate: "today",
                    name: this.$t('com.file.meeting.today-small'),
                    date:  new Date(),
                    meetingsList: [],
                },
                {
                    id: 1,
                    filterDate: "thisWeek",
                    name: this.$t('com.file.meeting.next-meetings'),
                    date: null,
                    meetingsList: [],
                },
            ],
        };
    },
    components: {
        MeetingsWrapper,
        FilterButton,
        SmallLoader,
    },
    mounted() {
        this.isLoading = true;
        this.reloadAllData();
    },
    computed: {
        meetingsReload() {
            return this.$store.state.appStore.groups;
        },
    },
    watch: {
        meetingsReload() {
            this.meetings[0].meetingsList = [];
            this.meetings[1].meetingsList = [];
            this.reloadAllData();
        },
    },
    methods: {
        reloadAllData() {
            this.isLoading = true;
            MeetingsService.sessions().then((response) => {
                this.isLoading = false;
                this.currentView = "all";

                this.meetings[0].meetingsList = [];
                this.meetings[1].meetingsList = [];

                const today = moment().startOf("day");

                response.data.forEach((item) => {
                    const itemDate = moment(item.meeting_date).startOf("day");
                    const itemEndDate = item.end_meeting_date ? moment(item.end_meeting_date).startOf("day") : null;

                    if ((itemDate.isSame(today) && (!itemEndDate || itemEndDate.isSame(today))) || // today
                        (itemDate.isBefore(today) && itemEndDate && (itemEndDate.isSame(today) || itemEndDate.isAfter(today))) || // start previous end in future
                        (itemDate.isSame(today) && itemEndDate && itemEndDate.isAfter(today))) { // start today end future
                        this.meetings[0].meetingsList.push({ ...item });
                    }
                    else if (itemDate.isAfter(today)) { // future
                        this.meetings[1].meetingsList.push({ ...item });
                    }
                });

                this.meetings[0].meetingsList.sort((a, b) => {
                    return new Date(a.meeting_date) - new Date(b.meeting_date);
                });


                this.meetings[1].meetingsList.sort((a, b) => {
                    return new Date(a.meeting_date) - new Date(b.meeting_date);
                });
            }).catch(() => {
                this.isLoading = false;
            });
        },
        sessionsToday() {
            this.isLoading = true;
                this.isLoading = false;
                this.isTodayLoaded = true;

        },
        sessionsTomorrow() {
            this.isLoading = true;
                this.isLoading = false;
                this.isTommorowLoaded = true;

        },
        sessionsThisWeek() {
            this.isLoading = true;
                this.isLoading = false;
                this.isThisWeekLoaded = true;

        },
        sessionsThisMonth() {
            this.isLoading = true;
                this.isLoading = false;
                this.isThisMonthLoaded = true;

        },
        handleChangeFilterButton(id) {
            this.filterButtons = this.filterButtons.map((item) => {
                if (item.id === id) {
                    item.selected = true;
                } else {
                    item.selected = false;
                }
                return item;
            });
        },
        formatDateToDisplay,
    },
};
</script>

<style lang="scss" scoped>
@use "../../../../../assets/scss/breakpoints.scss" as *;

    .meetings {
        max-height: 86vh;
        background-color: white;
        background: #ffffff;
        border: 1px solid #dce4ee;
        box-sizing: border-box;
        border-radius: 12px;
        box-sizing: border-box;

        &__bottom {
            max-height: 70vh;
            overflow-y: auto;
            position: relative;

            &::-webkit-scrollbar {
                width: 12px;
                height: 6px;
            }

            &::-webkit-scrollbar-thumb {
                background: #b5b8bd;
                border-radius: 30px;
            }

            &::-webkit-scrollbar-thumb:hover {
                background: #b5b8bd;
            }

            &::-webkit-scrollbar-track {
                background: #ffffff;
                border: 0.8px solid #dce4ee;
                border-radius: 30px;
                box-shadow: inset 0px 0px 0px 0px #f0f0f0;
            }
        }
    }

.meetings-top {
    border-bottom: 1px solid #dce4ee;
    padding: 20px 28px;
    display: flex;
    align-items: center;
    justify-content: space-between;

    &__icon {
        margin-right: 12px;
    }

    &__title {
        font-weight: 600;
        font-size: 18px;
        line-height: 132%;
        color: #00082c;
    }

    &__right {
        display: flex;
    }
}
</style>
